import React, { useEffect, useMemo } from "react";
import "./ToolsDrawer.css";

export default function ToolsDrawer({
  open,
  width = 340,
  activeKeys,
  toggleKey,
  onClose,
  mapRef,
  children,
}) {
  // Чтобы Яндекс-карта корректно пересчитала размеры после сдвига
  useEffect(() => {
    const map = mapRef?.current;
    if (!map) return;

    // подождём окончание CSS-transition (см. .toolsDrawer transition: 250ms)
    const t = setTimeout(() => {
      try {
        map.container?.fitToViewport?.();
      } catch {}
    }, 280);

    return () => clearTimeout(t);
  }, [open, width, mapRef]);

  const style = useMemo(
    () => ({ "--toolsDrawerWidth": `${width}px` }),
    [width]
  );

  return (
    <aside className={`toolsDrawer ${open ? "toolsDrawer--open" : ""}`} style={style}>
      <div className="toolsDrawer__head">
        <div className="toolsDrawer__title">Инструменты</div>
        <button className="toolsDrawer__close" onClick={onClose} title="Закрыть">✕</button>
      </div>
      <div className="toolsDrawer__body">
        {/*
          children — это уже готовые "элементы инструмента" (см. ниже ToolItem)
        */}
        {children}
      </div>
    </aside>
  );
}

// Простой “аккордеон-элемент” в стиле Unity
export function ToolItem({ title, open, onToggle, children, rightHint }) {
  return (
    <div className="toolItem">
      <button className={`toolItem__row ${open ? "toolItem__row--open" : ""}`} onClick={onToggle}>
        <span className="toolItem__caret">{open ? "▾" : "▸"}</span>
        <span className="toolItem__title">{title}</span>
        {rightHint ? <span className="toolItem__hint">{rightHint}</span> : null}
      </button>

      {open && <div className="toolItem__content">{children}</div>}
    </div>
  );
}